<template>
    <div>
        <section class="box bottom-space">
            <div class="trader">
                <div class="column-group horizontal-gutters">
                    <div class="all-30 large-40 medium-40 small-100 tiny-100">
                        <picture>
                            <img :src="`/` + mainLocation.ImagePath" onerror="this.onerror=null;this.src='/static/images/_placeholder-stand.svg';" />
                        </picture>
                    </div>
                    <div class="all-70 large-60 medium-60 small-100 tiny-100">
                        <h3 class="section-title"> {{ advertiserName }}</h3>
                        <p v-if="locationList.length == 1">{{ mainLocation.Address }}</p>
                        <p v-if="locationList.length == 1"><span> {{ mainLocation.District }}</span>, <span> {{
                                mainLocation.County }}</span></p>

                        <p v-if="mainLocation.Email && locationList.length == 1">
                            <a :href="`mailto:` + mainLocation.Email" target="_blank" class="icon email"> {{
                                mainLocation.Email }}</a>
                        </p>

                        <p v-if="website">
                            <a :href="website" target="_blank" class="url"> {{ website }}</a>
                        </p>

                        <p v-if="mainLocation.OpeningHours && locationList.length == 1">
                            {{ mainLocation.OpeningHours }}
                        </p>

                        <p v-if="phone || (mainLocation.Phone && locationList.length == 1)">
                            <a v-if="phone" class="ink-button icon mobile" :href="`tel:` + phone"> {{ phone }}</a>
                            <a v-if="mainLocation.Phone && locationList.length == 1" class="ink-button icon mobile mx-3"
                                :href="`tel:` + mainLocation.Phone"> {{ mainLocation.Phone }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </section>


        <section class="bottom-space" v-if="locationList.length > 1">
            <h3 class="section-title">Pontos de Venda</h3>
            <ul class="stands-list column-group half-gutters">
                <li class="all-33 small-50 tiny-100" v-for="location in locationList">
                    <div class="box">
                        <h3 class="section-title"> {{ location.Name }}</h3>
                        <p>{{ location.Address }}</p>
                        <p><span>{{ location.County }}</span>, <span v-if="location.County != location.District">{{
                                location.District }} </span></p>

                        <p v-if="location.Email">
                            <a :href="`mailto:${location.Email}`" target="_blank" class="icon email"> {{ location.Email
                                }}</a>
                        </p>

                        <p v-if="location.OpeningHours">
                            {{ location.OpeningHours.length > 200 ? location.OpeningHours.substring(0, 200) + '...' : location.OpeningHours }}
                        </p>

                        <p v-if="location.Phone">
                            <a class="ink-button icon mobile" :href="`tel:${location.Phone}`"> {{ location.Phone }}</a>
                        </p>
                    </div>
                </li>
            </ul>

            <div class="align-center" v-if="viewMore">
                <a class="ink-button" v-on:click="onViewMore">Ver Mais</a>
            </div>
        </section>
    </div>

</template>

<script>
import advertiserLocationsClient from "../scripts/services/advertiserLocationsClient.js";


export default {
    data() {
        return {
            locationList: [],
            allLocations: [],
            pageSize: 3,
            viewMore: true,
            mainLocation: {}
        };
    },

    props: {
        idPublic: {
            type: String,
            default: ""
        },
        advertiserName: {
            type: String,
            default: ""
        },
        address: {
            type: String,
            default: ""
        },
        districtName: {
            type: String,
            default: ""
        },
        countieName: {
            type: String,
            default: ""
        },
        email: {
            type: String,
            default: ""
        },
        website: {
            type: String,
            default: ""
        },
        phone: {
            type: String,
            default: ""
        },
        mainLocationIdPublic: {
            type: String,
            default: ""
        },
    },

    async created() {
        await this.getLocations();
    },

    methods: {
        async onViewMore() {
            this.pageSize += 3;

            if (this.pageSize >= this.allLocations.length) {
                this.viewMore = false;
            }

            this.locationList = this.allLocations.slice(0, this.pageSize);
        },

        async getLocations() {
            let result = await advertiserLocationsClient.SearchAdvertiserLocations(this.idPublic, 1000, 1);

            if (result) {
                this.allLocations = result.Items;

                if (this.mainLocationIdPublic) {
                    let mainLocation = this.allLocations.find(x => x.IdPublic === this.mainLocationIdPublic);
                    if (mainLocation) {
                        this.allLocations = this.allLocations.filter(x => x.IdPublic !== this.mainLocationIdPublic);
                        this.mainLocation = mainLocation;
                        // Order by name A-Z
                        this.allLocations.sort((a, b) => a.Name.localeCompare(b.Name));

                        this.allLocations.unshift(mainLocation);
                    }
                }

                this.locationList = this.allLocations.slice(0, this.pageSize);
            }

            if (this.pageSize >= this.allLocations.length) {
                this.viewMore = false;
            }
        }
    }
};
</script>